<template>
  <!-- <div class="page-header">
      <h2>用户 & 权限管理</h2>
      <div class="header-btn">
        <el-button type="primary" @click="openUserDialog"
          >新增系统账号</el-button
        >
        <el-button type="success" @click="openRoleDialog">新增角色</el-button>
      </div>
    </div> -->

  <div class="row-two">
    <div class="col-left">
      <div class="card-title">角色列表</div>
      <div class="role-list">
        <div
          class="role-item"
          v-for="r in roleList"
          :key="r.id"
          @click="selectRole(r)"
          :class="{ active: selRole.id === r.id }"
        >
          <div class="r-name">{{ r.roleName }}</div>
          <div class="r-desc">{{ r.desc }}</div>
          <div class="r-opt">
            <el-link type="primary" @click.stop="openRoleDialog(r)"
              >编辑</el-link
            >
            <el-link type="danger" @click.stop="delRole(r)">删除</el-link>
          </div>
        </div>
      </div>
    </div>

    <div class="col-right">
      <div class="card-title">
        账号管理（当前角色：{{ selRole.roleName || "全部" }}）
      </div>
      <el-table :data="userTable" height="420" class="data-table">
        <el-table-column label="账号" prop="username" />
        <el-table-column label="姓名" prop="realName" />
        <el-table-column label="绑定角色" prop="roleName" />
        <el-table-column label="管控分区" prop="area" />
        <el-table-column label="状态" prop="status">
          <template #default="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
              {{ scope.row.status === 1 ? "正常" : "禁用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template #default="scope">
            <el-button size="small" @click="openUserDialog(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="small"
              type="warning"
              @click="openPermDialog(scope.row)"
              >分配权限</el-button
            >
            <el-button size="small" type="danger" @click="delUser(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>

  <div class="log-card">
    <div class="card-title">账号操作日志</div>
    <el-table :data="operLog" height="240" class="data-table">
      <el-table-column label="操作人" prop="user" />
      <el-table-column label="操作类型" prop="type" />
      <el-table-column label="操作内容" prop="content" />
      <el-table-column label="操作时间" prop="time" />
      <el-table-column label="IP地址" prop="ip" />
    </el-table>
  </div>

  <el-dialog
    v-model="userDialogVisible"
    title="账号信息"
    width="680"
    class="dark-dialog"
  >
    <el-form :model="userForm" label-width="100px">
      <el-row :gutter="20">
        <el-col span="12">
          <el-form-item label="登录账号">
            <el-input v-model="userForm.username" />
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item label="真实姓名">
            <el-input v-model="userForm.realName" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col span="12">
          <el-form-item label="登录密码" v-if="!userForm.id">
            <el-input v-model="userForm.pwd" show-password />
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item label="所属角色">
            <el-select v-model="userForm.roleId" placeholder="选择角色">
              <el-option
                v-for="r in roleList"
                :key="r.id"
                :label="r.roleName"
                :value="r.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="厂区数据权限（分区隔离）">
        <el-checkbox-group v-model="userForm.areaIds">
          <el-checkbox
            v-for="a in areaList"
            :key="a.id"
            :label="a.name"
            :value="a.id"
          />
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="账号状态">
        <el-radio-group v-model="userForm.status">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="userDialogVisible = false">取消</el-button>
      <el-button type="primary" @click="saveUser">保存</el-button>
    </template>
  </el-dialog>

  <el-dialog
    v-model="roleDialogVisible"
    title="角色配置"
    width="520"
    class="dark-dialog"
  >
    <el-form :model="roleForm" label-width="90px">
      <el-form-item label="角色名称">
        <el-input v-model="roleForm.roleName" />
      </el-form-item>
      <el-form-item label="角色描述">
        <el-input v-model="roleForm.desc" type="textarea" />
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="roleDialogVisible = false">取消</el-button>
      <el-button type="primary" @click="saveRole">保存</el-button>
    </template>
  </el-dialog>

  <el-dialog
    v-model="permDialogVisible"
    title="菜单&数据权限分配"
    width="760"
    class="dark-dialog"
  >
    <div class="perm-tree">
      <el-tree
        :data="menuTree"
        show-checkbox
        node-key="id"
        v-model:checked-keys="checkedMenu"
        check-strictly
        default-expand-all
        class="dark-tree"
      />
    </div>

    <template #footer>
      <el-button @click="permDialogVisible = false">取消</el-button>
      <el-button type="primary" @click="savePerm">保存权限</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="js">
import { ref, reactive } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'

const roleList = ref([
  { id: 1, roleName: '超级管理员', desc: '全功能无限制' },
  { id: 2, roleName: '车间管理员', desc: '仅本车间数据权限' },
  { id: 3, roleName: '运维人员', desc: '仅点位查看' }
])

const selRole = ref({})
const roleDialogVisible = ref(false)
const roleForm = reactive({ id: '', roleName: '', desc: '' })

const areaList = ref([
  { id: 1, name: '一车间' },
  { id: 2, name: '二车间' },
  { id: 3, name: '储罐区' },
  { id: 4, name: '废气处理区' },
  { id: 5, name: '危废仓库' }
])

const page = ref(1)
const userTotal = ref(32)

const userTable = ref([
  { id: 1, username: 'admin', realName: '系统管理员', roleName: '超级管理员', area: '全部分区', status: 1 },
  { id: 2, username: 'ws001', realName: '王师傅', roleName: '车间管理员', area: '一车间、二车间', status: 1 }
])

const userDialogVisible = ref(false)
const userForm = reactive({
  id: '',
  username: '',
  realName: '',
  pwd: '',
  roleId: '',
  areaIds: [],
  status: 1
})

const menuTree = ref([
  {
    id: 1,
    label: '工作台首页',
    children: []
  },
  {
    id: 2,
    label: '安全监管',
    children: [
      { id: 21, label: '巡检记录' },
      { id: 22, label: '危险源台账' }
    ]
  },
  {
    id: 3,
    label: '环保监测',
    children: [
      { id: 31, label: 'GDS点位' },
      { id: 32, label: 'VOC监控' }
    ]
  },
  { id: 4, label: '告警处置' },
  { id: 5, label: '台账报表' },
  { id: 6, label: '系统配置' }
])

const permDialogVisible = ref(false)
const checkedMenu = ref([])
const currUser = ref({})

const operLog = ref([
  { user: 'admin', type: '账号编辑', content: '修改账号ws001权限', time: '2026-07-29 10:22', ip: '192.168.1.10' },
  { user: 'ws001', type: '登录', content: '系统登录', time: '2026-07-29 09:10', ip: '192.168.2.33' }
])

const openRoleDialog = (row) => {
  if (row) {
    roleForm.id = row.id
    roleForm.roleName = row.roleName
    roleForm.desc = row.desc
  } else {
    roleForm.id = ''
    roleForm.roleName = ''
    roleForm.desc = ''
  }
  roleDialogVisible.value = true
}

const saveRole = () => {
  ElMessage.success('角色保存成功')
  roleDialogVisible.value = false
}

const delRole = (r) => {
  ElMessageBox.confirm('确认删除该角色？').then(() => ElMessage.success('删除成功'))
}

const selectRole = (r) => {
  selRole.value = r
}

const openUserDialog = (row) => {
  if (row) {
    userForm.id = row.id
    userForm.username = row.username
    userForm.realName = row.realName
    userForm.pwd = ''
    userForm.roleId = row.roleId
    userForm.areaIds = row.areaIds || []
    userForm.status = row.status
  } else {
    userForm.id = ''
    userForm.username = ''
    userForm.realName = ''
    userForm.pwd = ''
    userForm.roleId = ''
    userForm.areaIds = []
    userForm.status = 1
  }
  userDialogVisible.value = true
}

const saveUser = () => {
  ElMessage.success('账号保存成功')
  userDialogVisible.value = false
}

const delUser = (row) => {
  ElMessageBox.confirm('确认删除账号？').then(() => ElMessage.success('删除成功'))
}

const openPermDialog = (row) => {
  currUser.value = row
  checkedMenu.value = [1, 2, 21]
  permDialogVisible.value = true
}

const savePerm = () => {
  ElMessage.success('权限分配保存完成')
  permDialogVisible.value = false
}
</script>

<style lang="scss" scoped>
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.page-header h2 {
  margin: 0;
  font-size: 20px;
  color: var(--text-main);
}

.page-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.row-two {
  display: flex;
  gap: 20px;
}

.col-left {
  width: 260px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 16px;
}

.col-right {
  flex: 1;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 16px;
}

.card-title {
  font-size: 16px;
  margin-bottom: 12px;
  font-weight: 500;
  color: var(--text-main);
}

.role-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 440px;
  overflow-y: auto;
}

.role-item {
  border: 1px solid rgba(64, 158, 255, 0.22);
  border-radius: 6px;
  padding: 12px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.02);
  transition: 0.2s;
}

.role-item:hover {
  background: var(--bg-card-hover);
}

.role-item.active {
  border-color: var(--primary-blue);
  background: rgba(64, 158, 255, 0.08);
  box-shadow: 0 0 0 1px rgba(64, 158, 255, 0.35);
}

.r-name {
  font-weight: 500;
  color: var(--text-main);
}

.r-desc {
  font-size: 12px;
  color: var(--text-sub);
  margin: 4px 0;
}

.r-opt {
  display: flex;
  gap: 10px;
  margin-top: 6px;
}

.log-card {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 16px;
}

.perm-tree {
  max-height: 400px;
  overflow-y: auto;
}

.dark-pagination :deep(.el-pagination) {
  color: var(--text-sub);
}

.dark-dialog :deep(.el-dialog) {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
}

.dark-dialog :deep(.el-dialog__title) {
  color: var(--text-main);
}

.dark-dialog :deep(.el-form-item label) {
  color: var(--text-sub);
}

.dark-tree :deep(.el-tree) {
  color: var(--text-main);
  background: transparent;
}

.dark-tree :deep(.el-tree-node__content:hover) {
  background: rgba(64, 158, 255, 0.04);
}
</style>
